import store from "@/store";
import { notify } from "@kyvg/vue3-notification";

export default function isActivatedUser({ next, router }) {
  let userStatus = store.getters["user/getCurrentUserStatus"];

  if (userStatus === "active") {
    return next();
  }

  notify({
    type: "info",
    text: "messages.user.inactive",
    duration: 5000,
  });

  return router.push({ name: "Dashboard" });
}
